import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import Sidebar from '@rio-cloud/rio-uikit/Sidebar';
import React, { useEffect } from 'react';
import { CustomFormattedMessage } from '../../../../i18n/i18n';
import { useAppDispatch, useAppSelector } from '../../../../state/hooks';
import {
  getSidebarTransaction,
  isTransactionsSidebarOpen,
  unselectTransaction,
} from '../../state/transactionsUiSlice';
import { useLocation } from 'react-router-dom';
import { TransactionSummaryTable } from './TransactionSummaryTable';
import { StationDetailsTable } from './StationDetailsTable';
import { BillingDetailsTable } from './BillingDetailsTable';
import { TransactionAmountsOverview } from './TransactionAmountsOverview';
import { SidebarVehicleHeadline } from '../../../../components/sidebar/SidebarVehicleHeadline';
import { TRANSACTIONS_ROUTE } from '../../../../routes/routes';

export const TransactionSidebar: React.FC = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(isTransactionsSidebarOpen);
  const transaction = useAppSelector(getSidebarTransaction);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== TRANSACTIONS_ROUTE) {
      dispatch(unselectTransaction());
    }
  }, [location.pathname]);

  const handleClose = () => {
    dispatch(unselectTransaction());
  };

  if (!isOpen || !transaction) {
    return <></>;
  }

  return (
    <ApplicationLayout.Sidebar className={'right'}>
      <Sidebar
        data-testid={'transactions-sidebar'}
        title={<CustomFormattedMessage id={'transactions.sidebar.title'} />}
        titleClassName={
          'padding-left-10 text-light text-uppercase text-size-16'
        }
        onClose={handleClose}
        resizable
        position={'right'}
        width={400}
        minWidth={330}
        maxWidth={600}
        fly
      >
        <div className={'padding-left-20 padding-right-20'}>
          <SidebarVehicleHeadline vehicle={transaction.vehicle} />
          <TransactionSummaryTable transaction={transaction} />
          <BillingDetailsTable transaction={transaction} />
          <StationDetailsTable
            location={transaction.locationDetails}
            fuelingDetails={transaction.fuelingDetails}
            chargingDetails={transaction.chargingDetails}
          />
          <TransactionAmountsOverview transaction={transaction} />
        </div>
      </Sidebar>
    </ApplicationLayout.Sidebar>
  );
};
